import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ErrorBoundary } from "./utils/bugsnag";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./app/store";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HotglueConfig from "@hotglue/widget";
import { Auth0ProviderWithNavigate } from "./components/Auth0ProviderWithNavigate/Auth0ProviderWithNavigate";
import { NotificationProvider } from "./context/NotificationContext";
import Gleap from "gleap";
import { ApolloProvider } from "@apollo/client";
import client from "./services/apolloClient";
import { initializeGA4 } from "./utils/analytics";

initializeGA4();
Gleap.initialize(process.env.REACT_APP_GLEAP_API_KEY || "");

function loadAuthorizeNetScript() {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

  const scriptUrl = isProduction
    ? "https://js.authorize.net/v1/Accept.js"
    : "https://jstest.authorize.net/v1/Accept.js";

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = scriptUrl;
  script.charset = "utf-8";

  document.body.appendChild(script);
}

loadAuthorizeNetScript();

function loadHelloBarScript() {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src =
    "https://my.hellobar.com/348626f815a95b2f274494d05f7dd7d7e235aca2.js";
  script.charset = "utf-8";
  script.async = true;

  document.body.appendChild(script);
}

loadHelloBarScript();

function loadMicrosoftClarityScript() {
  const clarityProjectId = "wicvl3juyk";

  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window, document, "clarity", "script", clarityProjectId);
}

loadMicrosoftClarityScript();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <Provider store={store}>
          <BrowserRouter>
            <HelmetProvider>
              <Auth0ProviderWithNavigate>
                <HotglueConfig
                  config={{
                    apiKey: "Z0DhQ4F5Th9UvKqSL2OLd9DvP47PUX3G2DMKXjKf",
                    envId: "dev.hg.mycertainpath.com",
                  }}
                >
                  <NotificationProvider>
                    <App />
                  </NotificationProvider>
                </HotglueConfig>
              </Auth0ProviderWithNavigate>
            </HelmetProvider>
          </BrowserRouter>
        </Provider>
      </ErrorBoundary>
    </ApolloProvider>
  </React.StrictMode>,
);

/**
 * If you want to start measuring performance in your app,
 * pass a function to log or send results (for example: console.log),
 * or send to an analytics endpoint.
 * Learn more: https://create-react-app.dev/docs/measuring-performance/#measuring-performance
 */
reportWebVitals(console.log);
